import React, { useEffect } from 'react';
import { CartProvider } from './context/CartContext';
import { optimizeImageLoading, addFadeInEffect } from './utils/imageOptimization';
import Header from './components/Header/Header';
import LandingPage from './components/LandingPage/LandingPage';
import FeaturedProducts from './components/FeaturedProducts/FeaturedProducts';
import Collections from './components/Collections/Collections';
import HistoryAndHeritage from './components/HistoryAndHeritage/HistoryAndHeritage';
import Clients from './components/Clients/Clients';
import ContactUs from './components/ContactUs/ContactUs';
import Footer from './components/Footer/Footer';
import Cart from './components/Cart/Cart';
import Toast from './components/Toast/Toast';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize image optimization
    addFadeInEffect();
    
    // Optimize image loading after component mount
    const timer = setTimeout(() => {
      optimizeImageLoading();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <CartProvider>
      <div className="App">
        <Header />
        <main>
          <LandingPage />
          <FeaturedProducts />
          <Collections />
          <HistoryAndHeritage />
          <Clients />
          <ContactUs />
        </main>
        <Footer />
        <Cart />
        <Toast />
        <WhatsAppButton />
      </div>
    </CartProvider>
  );
}

export default App;